/**
 * Displays an error message to the user.
 * @param {string} message - The error message to display.
 */
export function displayError(message: string): void {
	alert(message);
}
